import { Box } from "@mui/material";
import { Typography } from "@platform/design-system";

interface Props {
  title: string;
  date: string;
}

function DateValue({ title, date }: Props): React.JSX.Element {
  return (
    <Box display="flex" flexDirection="column" gap={0.5}>
      <Typography variant="body-medium">
        <strong>{title}</strong>
      </Typography>
      <Typography variant="body-medium">{date}</Typography>
    </Box>
  );
}

export { DateValue };
